const BASE_URL = 'https://www.hawaiiattorneydatabase.com'

export const LAST_UPDATED = '10/1/2026'

export const METADATA = {
  alternativeHeadline:
    'Comprehensive Directory of Licensed Attorneys in Hawaii: Insights for Legal Professionals and the General Public',
  audience: 'Legal Professionals, Researchers, Businesses, Journalists, Government, General Public',
  author: { name: 'Bronson Avila', url: 'https://www.bronsonavila.com/' },
  citation: { name: 'Hawaii State Bar Association', url: 'https://hsba.org/' },
  description:
    'A comprehensive, searchable database of attorneys licensed in Hawaii. Ideal for research, analysis, and public access to information on Hawaii attorneys.',
  keywords: 'Hawaii attorneys, attorney database, lawyer directory, Hawaii bar, public directory, attorney information',
  ogImage: `${BASE_URL}/og-image.jpg`,
  title: 'Hawaii Attorney Database',
  twitterImage: `${BASE_URL}/twitter-image.jpg`,
  url: `${BASE_URL}/`
}
